import React from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import About from "../pages/About";
import Terms from "../pages/Terms";
import Home from "../pages/Home";
import Contact from "../pages/Contact";
import GetAuth from "../components/GetAuth";
import NotFound from "../pages/NotFound";
import Charity from "../pages/Charity";

// ScrollToTop component
const ScrollToTop = () => {
  const { pathname } = useLocation();

  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

const NotUser = () => {
  return (
    <div className="not-user">
      {/* Add ScrollToTop inside Routes */}
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about-us" element={<About />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/investments" element={<Home />} />
        <Route path="/contact-us" element={<Contact />} />
        <Route path="/login" element={<GetAuth />} />
        <Route path="/node" element={<GetAuth />} />
        <Route path="/charity" element={<Charity />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </div>
  );
};

export default NotUser;